import React, { useState } from 'react';

import ConfirmationButton from 'components/ConfirmationButton';
import Button from 'components/DesignSystem/Button';
import TextFieldComponent from 'components/DesignSystem/TextField';

import type { GetAgroLocationGroups } from 'types/Meteorology/Agro/getAgroLocations';

import './index.scss';

export default function Group({
  group,
  onEdit,
  onDelete,
}:{
  group: GetAgroLocationGroups;
  onEdit: (id: number, name: string) => void;
  onDelete: (id: number) => void;
}) {
  const [editMode, setEditMode] = useState(false);
  const [newName, setNewName] = useState(group.name);

  const onSave = () => {
    setEditMode(false);
    onEdit(group.id, newName);
  };

  return (
    <div className="agro-edit-group-name">
      <div>
        {editMode ? (
          <TextFieldComponent
            value={newName}
            onChange={(e) => setNewName(e.target.value)}
            className="agro-edit-group-name-input"
          />
        ) : (
          group.name
        )}
      </div>
      <div className="edit-options-buttons">
        {editMode ? (
          <>
            <Button
              type="secondary"
              icon="checkmark"
              onClick={onSave}
              id="save-group"
            />
            <Button
              type="secondary"
              icon="close"
              onClick={() => setEditMode(false)}
              id="cancel-edit-group"
            />
          </>
        ) : (
          <>
            <Button
              type="secondary"
              icon="edit"
              onClick={() => setEditMode(true)}
              id="edit-group"
            />
            <ConfirmationButton
              type="secondary"
              icon="close"
              onClick={() => onDelete(group.id)}
              confirmationBody={(
                <p>
                  Tem certeza que deseja excluir o grupo
                  <strong>{` ${group.name}`}</strong>
                  ?
                </p>
              )}
              id="delete-group"
            />
          </>
        )}
      </div>
    </div>
  );
}
